import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { AggregateProvider } from '@/shared/provider/aggregate-provider/aggregate-provider.tsx'

const rootElement = document.getElementById('root')

if (!rootElement) {
	throw new Error('Root element not found')
}

createRoot(rootElement).render(
	<StrictMode>
		<AggregateProvider queryProviderProps={{ disableRetry: false }} />
	</StrictMode>,
)
